import { useCallback } from 'react'
import CertificationsService from '@/services/CertificationsService'

export default function useCertificationsApi() {
	const getAllCertifications = useCallback(options => CertificationsService.getAll(options), [])
	const searchCertifications = useCallback((searchText, options) => CertificationsService.search(searchText, options), [])
	const getCertificationById = useCallback(id => CertificationsService.getById(id), [])
	const createCertification = useCallback(payload => CertificationsService.create(payload), [])
	const updateCertification = useCallback((id, payload) => CertificationsService.update(id, payload), [])
	const deleteCertification = useCallback(id => CertificationsService.delete(id), [])

	return {
		createCertification,
		deleteCertification,
		getAllCertifications,
		getCertificationById,
		searchCertifications,
		updateCertification,
	}
}
